import { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

const DeleteWithPopup = ({
  onDelete,
  label = "Delete",
  message = "This action is permanent and cannot be undone.",
  redirectTo = null,
  buttonWidth = "auto",
  buttonHeight = "auto",
}) => {
  const [visible, setVisible] = useState(false);
  const toast = useRef(null);

  const handleDelete = async () => {
    setVisible(false);
    const result = await onDelete();
    const isSuccess = typeof result === "object" ? result.success : result;
    const errorMessage =
      typeof result === "object" && result.message
        ? result.message
        : "Failed to delete the resource. Please try again.";

    if (isSuccess) {
      toast.current.show({
        severity: "success",
        summary: "Successfully Deleted",
        detail: "This resource has been permanently deleted.",
        life: 5000,
      });

      if (redirectTo) {
        setTimeout(() => window.location.replace(redirectTo), 1000);
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Delete Failed",
        detail: errorMessage,
        life: 5000,
      });
    }
  };

  const footerContent = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setVisible(false)}
        className="p-button-text text-gray-400"
      />
      <Button
        label="Delete"
        icon="pi pi-trash"
        severity="danger"
        onClick={handleDelete}
        autoFocus
      />
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <div className={"p-0 flex flex-grow-1 justify-content-end"}>
        <Button
          label={label}
          severity="danger"
          icon="pi pi-trash"
          className={"p-button"}
          style={{ width: buttonWidth, height: buttonHeight }}
          onClick={() => setVisible(true)}
        />
      </div>
      <Dialog
        header="Are you sure you want to proceed?"
        visible={visible}
        style={{ width: "30rem" }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        <p>{message}</p>
      </Dialog>
    </>
  );
};

export default DeleteWithPopup;
